import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import Seo from "../components/Seo";
import { SectionHead, MediaTile, EmptyState, Loader } from "../components/Blocks";

const FILTERS = [
  { id: "recent", label: "Récent", params: {} },
  { id: "featured", label: "En vedette", params: { scope: "featured" } },
  { id: "events", label: "Événements", params: { scope: "events" } },
  { id: "partners", label: "Partenaires", params: { scope: "partners" } },
  { id: "ambassadors", label: "Ambassadeurs", params: { scope: "ambassadors" } },
  { id: "members", label: "Membres", params: { scope: "members" } },
  { id: "creators", label: "Créateurs", params: { scope: "creators" } },
  { id: "photo", label: "Photo", params: { type: "photo" } },
  { id: "video", label: "Vidéo", params: { type: "video" } },
];

const PAGE = 24;

export default function Discover() {
  const [active, setActive] = useState("recent");
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);

  const load = useCallback(async (filterId, skip = 0) => {
    const f = FILTERS.find((x) => x.id === filterId) || FILTERS[0];
    const { data } = await api.get("/public/media", { params: { ...f.params, limit: PAGE, skip } });
    setTotal(data.total);
    setItems((prev) => (skip === 0 ? data.items : [...(prev || []), ...data.items]));
  }, []);

  useEffect(() => {
    setItems(null);
    load(active, 0);
  }, [active, load]);

  return (
    <div data-testid="discover-page" className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
      <Seo
        title="Découvrir"
        description="Le fil visuel de VytaliBoots : photos et vidéos des événements, partenaires, ambassadeurs et créateurs Vytali."
        path="/decouvrir"
        kind="home"
      />
      <SectionHead as="h1" label="Fil visuel" title="Découvrir">
        Contenu classé de façon chronologique et par mise en vedette. Aucune recommandation
        algorithmique.
      </SectionHead>

      <div className="flex flex-wrap gap-3 mb-10" data-testid="discover-filters">
        {FILTERS.map((f) => (
          <button
            key={f.id}
            className="vb-chip"
            data-active={active === f.id}
            data-testid={`discover-filter-${f.id}`}
            onClick={() => setActive(f.id)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {items === null ? (
        <Loader />
      ) : items.length === 0 ? (
        <EmptyState message="Aucun média pour ce filtre." testid="discover-empty" />
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-4" data-testid="discover-grid">
            {items.map((m, i) => (
              <MediaTile key={m.id} item={m} testid={`discover-tile-${i}`} className="aspect-square" />
            ))}
          </div>
          {items.length < total && (
            <div className="mt-12 text-center">
              <button
                className="vb-btn vb-btn-ghost"
                data-testid="discover-load-more"
                onClick={() => load(active, items.length)}
              >
                Charger plus
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
